//auth
export const USER_REGISTRATION = 'USER_REGISTRATION';
export const USER_REGISTRATION_SUCCESS = 'USER_REGISTRATION_SUCCESS';
export const USER_REGISTRATION_ERROR = 'USER_REGISTRATION_ERROR';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const GOOGLE_LOGIN = 'GOOGLE_LOGIN';
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS';
export const GOOGLE_LOGIN_ERROR = 'GOOGLE_LOGIN_ERROR';
export const FACEBOOK_LOGIN = 'FACEBOOK_LOGIN';
export const FACEBOOK_LOGIN_SUCCESS = 'FACEBOOK_LOGIN_SUCCESS';
export const FACEBOOK_LOGIN_ERROR = 'FACEBOOK_LOGIN_ERROR';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const CHECK_AUTH = 'CHECK_AUTH';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_ERROR = 'USER_LOGOUT_ERROR';
export const RESET_LOGOUT_REDIRECTION = 'RESET_LOGOUT_REDIRECTION';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_ERROR = 'FETCH_USER_PROFILE_ERROR';
export const FETCH_USER_IMAGES = 'FETCH_USER_IMAGES';
export const FETCH_USER_IMAGES_SUCCESS = 'FETCH_USER_IMAGES_SUCCESS';
export const FETCH_USER_IMAGES_ERROR = 'FETCH_USER_IMAGES_ERROR';

//content
export const HERO_SLIDER = 'HERO_SLIDER';
export const HERO_SLIDER_SUCCESS = 'HERO_SLIDER_SUCCESS';
export const HERO_SLIDER_ERROR = 'HERO_SLIDER_ERROR';
export const FETCH_FRONT_MENU = 'FETCH_FRONT_MENU';
export const FETCH_FRONT_MENU_SUCCESS = 'FETCH_FRONT_MENU_SUCCESS';
export const FETCH_FRONT_MENU_ERROR = 'FETCH_FRONT_MENU_ERROR';
export const FETCH_PARENT_CATEGORIES = 'FETCH_PARENT_CATEGORIES';
export const FETCH_PARENT_CATEGORIES_SUCCESS =
  'FETCH_PARENT_CATEGORIES_SUCCESS';
export const FETCH_PARENT_CATEGORIES_ERROR = 'FETCH_PARENT_CATEGORIES_ERROR';
export const FETCH_BRANDS = 'FETCH_BRANDS';
export const FETCH_BRANDS_SUCCESS = 'FETCH_BRANDS_SUCCESS';
export const FETCH_BRANDS_ERROR = 'FETCH_BRANDS_ERROR';
export const FETCH_HIGHLIGHTS = 'FETCH_HIGHLIGHTS';
export const FETCH_HIGHLIGHTS_SUCCESS = 'FETCH_HIGHLIGHTS_SUCCESS';
export const FETCH_HIGHLIGHTS_ERROR = 'FETCH_HIGHLIGHTS_ERROR';
export const MOST_POPULAR = 'MOST_POPULAR';
export const MOST_POPULAR_SUCCESS = 'MOST_POPULAR_SUCCESS';
export const MOST_POPULAR_ERROR = 'MOST_POPULAR_ERROR';

//products
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_ERROR = 'FETCH_PRODUCTS_ERROR';
export const FETCH_PRODUCT_DETAILS = 'FETCH_PRODUCT_DETAILS';
export const FETCH_PRODUCT_DETAILS_SUCCESS = 'FETCH_PRODUCT_DETAILS_SUCCESS';
export const FETCH_PRODUCT_DETAILS_ERROR = 'FETCH_PRODUCT_DETAILS_ERROR';
export const CHANGE_PRODUCT_DETAILS = 'CHANGE_PRODUCT_DETAILS';
export const FETCH_PRODUCT_REVIEWS = 'FETCH_PRODUCT_REVIEWS';
export const FETCH_PRODUCT_REVIEWS_SUCCESS = 'FETCH_PRODUCT_REVIEWS_SUCCESS';
export const FETCH_PRODUCT_REVIEWS_ERROR = 'FETCH_PRODUCT_REVIEWS_ERROR';
export const FETCH_RELATED_PRODUCTS = 'FETCH_RELATED_PRODUCTS';
export const FETCH_RELATED_PRODUCTS_SUCCESS = 'FETCH_RELATED_PRODUCTS_SUCCESS';
export const FETCH_RELATED_PRODUCTS_ERROR = 'FETCH_RELATED_PRODUCTS_ERROR';
export const UPDATE_RECENTLY_VIEWED = 'UPDATE_RECENTLY_VIEWED';
export const UPDATE_RECENTLY_VIEWED_SUCCESS = 'UPDATE_RECENTLY_VIEWED_SUCCESS';
export const UPDATE_RECENTLY_VIEWED_ERROR = 'UPDATE_RECENTLY_VIEWED_ERROR';

//cart
export const FETCH_CART_ITEMS = 'FETCH_CART_ITEMS';
export const FETCH_CART_ITEMS_SUCCESS = 'FETCH_CART_ITEMS_SUCCESS';
export const FETCH_CART_ITEMS_ERROR = 'FETCH_CART_ITEMS_ERROR';
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const UPDATE_CART_ITEM_SUCCESS = 'UPDATE_CART_ITEM_SUCCESS';
export const UPDATE_CART_ITEM_ERROR = 'UPDATE_CART_ITEM_ERROR';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const REMOVE_CART_ITEM_SUCCESS = 'REMOVE_CART_ITEM_SUCCESS';
export const REMOVE_CART_ITEM_ERROR = 'REMOVE_CART_ITEM_ERROR';
export const FETCH_CART_COUNT = 'FETCH_CART_COUNT';
export const FETCH_CART_COUNT_SUCCESS = 'FETCH_CART_COUNT_SUCCESS';
export const FETCH_CART_COUNT_ERROR = 'FETCH_CART_COUNT_ERROR';
export const MOVE_TO_WISHLIST = 'MOVE_TO_WISHLIST';
export const MOVE_TO_WISHLIST_SUCCESS = 'MOVE_TO_WISHLIST_SUCCESS';
export const MOVE_TO_WISHLIST_ERROR = 'MOVE_TO_WISHLIST_ERROR';
export const FETCH_CATEGORY_TREE = 'FETCH_CATEGORY_TREE';
export const FETCH_CATEGORY_TREE_SUCCESS = 'FETCH_CATEGORY_TREE_SUCCESS';
export const FETCH_CATEGORY_TREE_ERROR = 'FETCH_CATEGORY_TREE_ERROR';
export const FETCH_CATEGORY_FILTERS = 'FETCH_CATEGORY_FILTERS';
export const FETCH_CATEGORY_FILTERS_SUCCESS = 'FETCH_CATEGORY_FILTERS_SUCCESS';
export const FETCH_CATEGORY_FILTERS_ERROR = 'FETCH_CATEGORY_FILTERS_ERROR';
export const FETCH_DAILY_DEALS = 'FETCH_DAILY_DEALS';
export const FETCH_DAILY_DEALS_SUCCESS = 'FETCH_DAILY_DEALS_SUCCESS';
export const FETCH_DAILY_DEALS_ERROR = 'FETCH_DAILY_DEALS_ERROR';
export const FETCH_COUPON_DETAILS = 'FETCH_COUPON_DETAILS';
export const FETCH_COUPON_DETAILS_SUCCESS = 'FETCH_COUPON_DETAILS_SUCCESS';
export const FETCH_COUPON_DETAILS_ERROR = 'FETCH_COUPON_DETAILS_ERROR';

//address
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_ERROR = 'ADD_ADDRESS_ERROR';
export const FETCH_ADDRESSES = 'FETCH_ADDRESSES';
export const FETCH_ADDRESSES_SUCCESS = 'FETCH_ADDRESSES_SUCCESS';
export const FETCH_ADDRESSES_ERROR = 'FETCH_ADDRESSES_ERROR';
export const REMOVE_ADDRESS = 'REMOVE_ADDRESS';
export const REMOVE_ADDRESS_SUCCESS = 'REMOVE_ADDRESS_SUCCESS';
export const REMOVE_ADDRESS_ERROR = 'REMOVE_ADDRESS_ERROR';
export const MODIFY_ADDRESS = 'MODIFY_ADDRESS';
export const MODIFY_ADDRESS_SUCCESS = 'MODIFY_ADDRESS_SUCCESS';
export const MODIFY_ADDRESS_ERROR = 'MODIFY_ADDRESS_ERROR';

//orders
export const ADD_ORDER = 'ADD_ORDER';
export const ADD_ORDER_SUCCESS = 'ADD_ORDER_SUCCESS';
export const ADD_ORDER_ERROR = 'ADD_ORDER_ERROR';
export const FETCH_ORDER_DETAIL = 'FETCH_ORDER_DETAIL';
export const FETCH_ORDER_DETAIL_SUCCESS = 'FETCH_ORDER_DETAIL_SUCCESS';
export const FETCH_ORDER_DETAIL_ERROR = 'FETCH_ORDER_DETAIL_ERROR';
export const FETCH_ORDER_DETAIL_RZ = 'FETCH_ORDER_DETAIL_RZ';
export const FETCH_ORDER_DETAIL_RZ_SUCCESS = 'FETCH_ORDER_DETAIL_RZ_SUCCESS';
export const FETCH_ORDER_DETAIL_RZ_ERROR = 'FETCH_ORDER_DETAIL_RZ_ERROR';
export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_ERROR = 'FETCH_ORDERS_ERROR';
export const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS';
export const UPDATE_ORDER_STATUS_SUCCESS = 'UPDATE_ORDER_STATUS_SUCCESS';
export const UPDATE_ORDER_STATUS_ERROR = 'UPDATE_ORDER_STATUS_ERROR';

//reviews
export const SUBMIT_PRODUCT_REVIEW = 'SUBMIT_PRODUCT_REVIEW';
export const SUBMIT_PRODUCT_REVIEW_SUCCESS = 'SUBMIT_PRODUCT_REVIEW_SUCCESS';
export const SUBMIT_PRODUCT_REVIEW_FAIL = 'SUBMIT_PRODUCT_REVIEW_FAIL';
export const FETCH_REVIEW_DETAIL = 'FETCH_REVIEW_DETAIL';
export const FETCH_REVIEW_DETAIL_SUCCESS = 'FETCH_REVIEW_DETAIL_SUCCESS';
export const FETCH_REVIEW_DETAIL_ERROR = 'FETCH_REVIEW_DETAIL_ERROR';
export const MODIFY_REVIEW = ' MODIFY_REVIEW';
export const MODIFY_REVIEW_SUCCESS = ' MODIFY_REVIEW_SUCCESS';
export const MODIFY_REVIEW_ERROR = ' MODIFY_REVIEW_ERROR';
export const FETCH_REVIEW_LIST = 'FETCH_REVIEW_LIST';
export const FETCH_REVIEW_LIST_SUCCESS = 'FETCH_REVIEW_LIST_SUCCESS';
export const FETCH_REVIEW_LIST_ERROR = 'FETCH_REVIEW_LIST_ERROR';

//wishlist
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const ADD_TO_WISHLIST_SUCCESS = 'ADD_TO_WISHLIST_SUCCESS';
export const ADD_TO_WISHLIST_ERROR = 'ADD_TO_WISHLIST_ERROR';
export const FETCH_WISHLIST_ITEMS = 'FETCH_WISHLIST_ITEMS';
export const FETCH_WISHLIST_ITEMS_SUCCESS = 'FETCH_WISHLIST_ITEMS_SUCCESS';
export const FETCH_WISHLIST_ITEMS_ERROR = 'FETCH_WISHLIST_ITEMS_ERROR';
export const REMOVE_WISHLIST_ITEM = 'REMOVE_WISHLIST_ITEM';
export const REMOVE_WISHLIST_ITEM_SUCCESS = 'REMOVE_WISHLIST_ITEM_SUCCESS';
export const REMOVE_WISHLIST_ITEM_ERROR = 'REMOVE_WISHLIST_ITEM_ERROR';

//payment
export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_ERROR = 'CREATE_PAYMENT_ERROR';
